import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { GridColumn } from "arv-reactcomponents";

import ConsignmentImage from "../ConsignmentImage";
class ConsignmentProduct extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { items, returnClick, addressId } = this.props;
    const itemsArray = items.map((item, index) => {
      return (
        <ConsignmentImage.component
          item={item}
          returnClick={returnClick}
          addressId={addressId}
          key={index}
        >
        </ConsignmentImage.component>

      );
  });
  return(
      <GridColumn className = "nwc-grid-col-md nw-consignment-left" >
      { itemsArray }
      </GridColumn>
    );
}
}

ConsignmentProduct.defaultProps = {
  items: [],
};

ConsignmentProduct.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  returnClick: PropTypes.func.isRequired,
  addressId: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentProduct,
  component: ConsignmentProduct,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/ConsignmentProduct/index.js